<template>
  <div class="section">
    <div class="box">
      <div class="columns">
        <div class="column">
          <!--<b-field label="Date Range" horizontal><b-datepicker v-model="dates" range @input="GetData()"></b-datepicker></b-field>-->
          <b-field label="Date Range" horizontal
            ><date-range-picker
              ref="picker"
              :opens="'right'"
              :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
              :minDate="'2022-06-01'"
              :maxDate="dayjs().subtract(1, 'days').format()"
              :singleDatePicker="false"
              :timePicker="false"
              :timePicker24Hour="false"
              :showWeekNumbers="true"
              :showDropdowns="true"
              :showRanges="true"
              :autoApply="true"
              v-model="dateRange"
              :linkedCalendars="false"
              @finish-selection="GetData()"
              @select="GetData()"
            >
              <div slot="header" class="slot">
                <div class="box has-background-primary date-selection-header">
                  <h3 class="title is-size-5">Range Selection</h3>
                  <p class="subtitle is-size-7">Please select two dates, or choose one to the left</p>
                </div>
              </div></date-range-picker
            >
          </b-field>
          <b-field label="Currency" horizontal
            ><b-select v-model="selected_currency" @input="GetData()"
              ><option value="USD">$ US Dollars</option>
              <option value="GBP">£ Great British Pounds</option>
              <option value="EUR">€ Euros</option>
              <option value="RUB">₽ Rubles</option></b-select
            ></b-field
          >
        </div>
        <div class="column">
          <b-field label="Region" horizontal
            ><b-select v-model="selected_region" @input="GetData()"
              ><option v-for="region in Regions" :key="region">{{ region }}</option></b-select
            ></b-field
          >
          <b-field label="Customer" horizontal
            ><b-select v-model="selected_customer" @input="GetData()"
              ><option v-for="customer in CustomerList" :key="customer.id" :value="customer">{{ customer.CustomerFriendlyName }}</option></b-select
            ></b-field
          >
          <b-field label="Interval" horizontal>
            <b-select v-model="selected_interval" @input="GetData()">
              <option>Daily</option>
              <option>Weekly</option>
              <option>Monthly</option>
            </b-select>
          </b-field>
          <!--<b-field><b-autocomplete v-model="selected_customer_name" open-on-focus :data="customerList" @input="(option) => (selected_customer = option)" append-to-body></b-autocomplete></b-field>-->
        </div>
      </div>
      <template v-if="loaded">
        <div class="columns is-desktop">
          <div class="column">
            <p class="has-text-centered is-size-5 has-text-weight-semibold">Outcomes</p>
            <line-chart
              :data="interval_totals"
              :series="[
                { dataColumn: 'booked', headingColumn: 'date', color: '#47d061' },
                { dataColumn: 'queue', headingColumn: 'date', color: '#D5AC4E' },
                { dataColumn: 'hungup', headingColumn: 'date', color: '#F71735' },
                { dataColumn: 'chargeableCalls', headingColumn: 'date', color: '#283618' },
              ]"
              :headingColumn="'date'"
              class="big-chart"
            ></line-chart>
          </div>
        </div>
        <div class="horizontal-seperator"></div>
        <div class="level" v-if="loaded">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Total Sessions</p>
              <p class="title">
                {{
                  totals.find((search) => {
                    return search.name == "bookableSessions";
                  }).value | commaSeperators
                }}
              </p>
            </div>
          </div>
          <template v-for="outcome of totals">
            <div class="level-item has-text-centered" :key="outcome.title" v-if="shown_totals.includes(outcome.name)">
              <div>
                <p class="heading">{{ outcome.name }}</p>
                <p class="title">{{ outcome.value | commaSeperators }}</p>
              </div>
            </div>
          </template>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Conversion Rate</p>
              <p class="title">
                {{
                  (
                    (totals.find((totalSearch) => {
                      return totalSearch.name == "booked";
                    }).value /
                      totals.find((totalSearch) => {
                        return totalSearch.name == "bookableSessions";
                      }).value) *
                    100
                  ).toFixed()
                }}%
              </p>
            </div>
          </div>
        </div>
        <div class="horizontal-seperator"></div>
        <div class="columns">
          <div class="column">
            <div>
              <p class="has-text-centered is-size-5 has-text-weight-semibold">Outcomes</p>
              <doughnut-chart :data="doughnut_data" dataColumn="value" headingColumn="name" :showLegend="true" :showTooltips="false" class="big-chart"></doughnut-chart>
            </div>
          </div>
          <div class="vertical-seperator"></div>
          <div class="column">
            <p class="has-text-centered is-size-5 has-text-weight-semibold">Bookings</p>
            <bar-chart :data="bookings_data" dataColumn="bookings" headingColumn="date" class="big-chart"></bar-chart>
          </div>
        </div>
        <div class="horizontal-seperator"></div>
        <div class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Customers Live</p>
              <p class="title">{{ CustomerList.length - 1 }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered" v-if="selected_region == 'All Regions'">
            <div>
              <p class="heading">Regions</p>
              <p class="title">{{ Regions.length - 1 }}</p>
            </div>
          </div>
        </div>
        <div class="horizontal-seperator" v-if="selected_region == 'All Regions'"></div>
        <div class="columns" v-if="selected_region == 'All Regions'">
          <div class="column">
            <div>
              <h2 class="is-capitalized is-flex is-justify-content-center is-size-4 title">Region Bookings</h2>
              <doughnut-chart :data="region_data" :headingColumn="'name'" :dataColumn="'booked'" :showLegend="true" :showTooltips="false" class="big-chart"></doughnut-chart>
            </div>
          </div>
        </div>
        <div class="horizontal-seperator"></div>
        <div class="columns">
          <div class="column">
            <b-table :data="customer_data" class="table-height" sticky-header striped hoverable>
              <b-table-column label="UID" v-slot="props">{{
                allCustomers.find((customerSearch) => {
                  return customerSearch.id == props.row.id;
                }).uuid
              }}</b-table-column>
              <b-table-column label="Name" v-slot="props">{{
                allCustomers.find((customerSearch) => {
                  return customerSearch.id == props.row.id;
                }).CustomerFriendlyName
              }}</b-table-column>
              <b-table-column field="booked" label="Bookings" v-slot="props" sortable>{{ props.row.booked ? props.row.booked : 0 }}</b-table-column>
              <b-table-column field="queue" label="Queue" v-slot="props" sortable>{{ props.row.queue ? props.row.queue : 0 }}</b-table-column>
              <b-table-column field="chargeableCalls" label="Chargeable" v-slot="props" sortable>{{ props.row.chargeableCalls ? props.row.chargeableCalls : 0 }}</b-table-column>
              <b-table-column field="chargeableCalls" label="Revenue" v-slot="props" sortable>{{
                CurrencyFormatter(CalculateCharge(props.row.id, props.row.chargeableCalls).toFixed(2))
              }}</b-table-column>
            </b-table>
          </div>
        </div>
      </template>
      <template v-else-if="loading"
        ><div><b-progress size="is-large" show-value></b-progress></div
      ></template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYear);
import DoughnutChart from "../../../voiceplus/components/charts/Doughnut-Chart.vue";
import BarChart from "../../components/charts/Bar-Chart.vue";
import LineChart from "../../components/charts/Line-Chart.vue";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  components: { DoughnutChart, BarChart, LineChart, DateRangePicker },
  props: {},
  data: function () {
    return {
      loaded: false,
      loading: true,
      allCustomers: [],
      customers: [],
      currencies: [],
      currency_symbols: {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
        CAD: "$", // Canadian Dollar
        AUD: "$", // Australian Dollar,
        RUB: "₽",
      },
      dates: [],
      dateRange: {},
      newApiUrl: "https://api.jeak.co.uk",
      dayjs: dayjs,
      data: [],
      totals: [],
      interval_totals: [],
      doughnut_data: [],
      bookings_data: [],
      chargeableTotal: 0,
      region_data: [],
      customer_info: [],
      customer_data: [],
      shown_customer_data: [],
      shown_totals: ["booked", "chargeableCalls", "not chargeable", "revenue"],
      selected_region: "All Regions",
      selected_customer: { id: -1, CustomerFriendlyName: "All Customers" },
      selected_customer_name: "",
      selected_currency: "USD",
      selected_interval: "Daily",
      totalCharge: 0,
    };
  },
  methods: {
    GetData: async function () {
      this.loaded = false;
      document.cookie = `dateFrom=${this.dateRange["startDate"]};`;
      document.cookie = `dateTo=${this.dateRange["endDate"]};`;
      document.cookie = `region=${this.selected_region};`;
      document.cookie = `customer=${JSON.stringify(this.selected_customer)};`;
      document.cookie = `currency=${this.selected_currency};`;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      let from = dayjs(this.dateRange["startDate"]).format("YYYY-MM-DD");
      let to = dayjs(this.dateRange["endDate"]).format("YYYY-MM-DD");
      const response = await axios.get(this.newApiUrl + `/stats/customer/outcomes?from=${from}&to=${to}&interval=${this.selected_interval}`, config);
      this.data = [];
      for (const [key, value] of Object.entries(response.data)) {
        let tmpObj = { date: "", value: {} };
        switch (this.selected_interval.toLowerCase()) {
          case "daily":
          default:
            tmpObj.date = dayjs(key).format("ddd DD-MM-YYYY");
            break;
          case "weekly":
            tmpObj.date = dayjs().week(key).format("ddd DD-MM-YYYY");
            break;
          case "monthly":
            tmpObj.date = dayjs().month(key).format("ddd DD-MM-YYYY");
            break;
          case "yearly":
            break;
        }

        for (const [customerId, customerData] of Object.entries(value)) {
          if (this.selected_region != "All Regions" && this.selected_customer.id > 0) {
            if (customerId == this.selected_customer.id) {
              tmpObj.value[customerId] = customerData;
            }
          } else if (this.selected_region != "All Regions") {
            let foundCustomer = this.allCustomers.find((customerSearch) => {
              return customerSearch.id == customerId;
            });
            if (foundCustomer.billing_region == this.selected_region) {
              tmpObj.value[customerId] = customerData;
            }
          } else if (this.selected_customer.id > 0) {
            if (customerId == this.selected_customer.id) {
              tmpObj.value[customerId] = customerData;
            }
          } else {
            tmpObj.value[customerId] = customerData;
          }
        }
        this.data.push(tmpObj);
      }
      this.FormatData();
    },
    FormatData: async function () {
      //Initialise all the data - partly to wipe old data
      this.interval_totals = [];
      this.totals = [];
      this.doughnut_data = [];
      this.region_data = [];
      this.chargeableTotal = 0;
      this.bookings_data = [];
      this.totalCharge = 0;
      this.customer_data = [];
      //Loop all the days returned
      //Format is Object of Days with Object of customerId => Data in each day
      for (const date of this.data) {
        let foundDay = this.interval_totals.find((totalSearch) => {
          return totalSearch.date == date;
        });
        if (!foundDay) {
          this.interval_totals.push({ date: date.date });
          foundDay = this.interval_totals[this.interval_totals.length - 1];
        }
        for (const [customerId, customerOutcomes] of Object.entries(date.value)) {
          let customerInfo = this.allCustomers.find((customerSearch) => {
            return customerSearch.id == customerId;
          });
          let regionData = this.region_data.find((regionSearch) => {
            return regionSearch.name == customerInfo.billing_region;
          });
          if (!regionData) {
            this.region_data.push({ name: customerInfo.billing_region });
            regionData = this.region_data[this.region_data.length - 1];
          }
          let customerData = this.customer_data.find((customerSearch) => {
            return customerSearch.id == customerId;
          });
          if (!customerData) {
            this.customer_data.push({ id: customerId });
            customerData = this.customer_data[this.customer_data.length - 1];
          }
          for (const [outcomeName, outcomeValue] of Object.entries(customerOutcomes)) {
            if (outcomeName == "chargeableCalls") {
              this.chargeableTotal += outcomeValue;
              this.totalCharge += this.CalculateCharge(customerId, outcomeValue);
            }
            let foundDailyOutcome = foundDay[outcomeName];
            if (!foundDailyOutcome) {
              foundDay[outcomeName] = 0;
            }
            foundDay[outcomeName] += outcomeValue;

            if (!regionData[outcomeName]) regionData[outcomeName] = 0;
            regionData[outcomeName] += outcomeValue;
            if (!customerData[outcomeName]) {
              customerData[outcomeName] = 0;
              customerData[outcomeName] = outcomeValue;
            } else {
              customerData[outcomeName] += outcomeValue;
            }

            let foundOutcome = this.totals.find((totalSearch) => {
              return totalSearch.name == outcomeName;
            });
            if (!foundOutcome) {
              this.totals.push({ name: outcomeName, value: outcomeValue });
            } else {
              foundOutcome.value += outcomeValue;
            }
          }
        }
      }

      let foundBookings = this.totals.find((totalsSearch) => {
        return totalsSearch.name == "booked";
      });
      let foundChargeable = this.totals.find((totalsSearch) => {
        return totalsSearch.name == "chargeableCalls";
      });
      this.totals.push({ name: "not chargeable", value: foundBookings.value - foundChargeable.value });

      this.totals.push({ name: "revenue", value: this.CurrencyFormatter(this.totalCharge.toFixed(2)) });

      //Dougnut chart format
      this.doughnut_data = this.totals.filter((totalsSearch) => {
        return (
          totalsSearch.name != "bookableSessions" &&
          totalsSearch.name != "chargeableCalls" &&
          totalsSearch.name != "fixedLocCalls" &&
          totalsSearch.name != "revenue" &&
          totalsSearch.name != "not chargeable" &&
          totalsSearch.name != "recogSeconds" &&
          totalsSearch.name != "enhancedRecogSeconds" &&
          totalsSearch.name != "dialogFlowRequests" &&
          totalsSearch.name.includes("-") != true
        );
      });

      for (const key in this.interval_totals) {
        this.bookings_data.push({
          date: this.interval_totals[key].date,
          bookings: this.interval_totals[key].booked,
        });
      }

      this.loaded = true;
    },
    GetAllCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(`https://api.disctools.co.uk/api/customers`, config);
      this.allCustomers = response.data.data;
    },
    GetVoicePlusCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const response = await axios.get(this.newApiUrl + "/customers", config);
      this.customers = response.data;
    },
    CalculateCharge: function (customerId, count) {
      if (count == 0) return 0;
      let foundCustomer = this.customers.find((customerSearch) => {
        return customerSearch.disctools_id == customerId;
      });
      if (!foundCustomer) {
        console.log("Customer with id: " + customerId);
      }
      return count * foundCustomer.call_cost * this.currencies[foundCustomer.currency];
    },
    GetCurrencies: async function () {
      axios.get(`https://v6.exchangerate-api.com/v6/b4c58da02d0282ef7b452820/latest/USD`).then((response) => {
        this.currencies = response.data.conversion_rates;
        this.currencies = Object.keys(this.currencies)
          .sort()
          .reduce((result, key) => {
            result[key] = this.currencies[key];
            return result;
          }, {});
      });
    },
    CurrencyFormatter: function (x) {
      return `${this.currency_symbols[this.selected_currency]}${(x * this.currencies[this.selected_currency]).toFixed(2)}`;
    },
    ProgressBar: async function (value) {
      await new Promise();
    },
    dateFormat: function (classes, date) {
      dayjs(date).format("DD-MM-YYYY");
      return classes;
    },
  },
  filters: {
    commaSeperators: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  async beforeMount() {
    await this.GetAllCustomers();
    await this.GetVoicePlusCustomers();
    await this.GetCurrencies();
    try {
      this.dateRange = JSON.parse(
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("dateRange="))
          .split("=")[1]
      );
      this.selected_currency = document.cookie
        .split("; ")
        .find((row) => row.startsWith("currency="))
        .split("=")[1];
      this.selected_region = document.cookie
        .split("; ")
        .find((row) => row.startsWith("region="))
        .split("=")[1];
      this.selected_customer = JSON.parse(
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("customer="))
          .split("=")[1]
      );
    } catch (err) {
      if (!this.dateRange["startDate"]) {
        this.dateRange["startDate"] = dayjs().set("date", 1);
        this.dateRange["endDate"] = dayjs().subtract(1, "days");
      }
    }
    this.$forceUpdate();

    this.GetData();
  },
  computed: {
    Regions: function () {
      let regionList = ["All Regions"];
      this.allCustomers.forEach((customer) => {
        if (!regionList.includes(customer.billing_region)) regionList.push(customer.billing_region);
      });
      return regionList;
    },
    CustomerList: function () {
      let customerList = [];
      this.allCustomers.forEach((customer) => {
        let foundCustomer = this.customers.find((customerSearch) => {
          return customerSearch.disctools_id == customer.id;
        });
        if ((customer.billing_region == this.selected_region && foundCustomer) || (this.selected_region == "All Regions" && foundCustomer)) customerList.push(customer);
      });
      customerList.sort((a, b) => {
        if (a.CustomerFriendlyName.toLowerCase() < b.CustomerFriendlyName.toLowerCase()) return -1;
        else if (a.CustomerFriendlyName.toLowerCase() > b.CustomerFriendlyName.toLowerCase()) return 1;
        else return 0;
      });
      customerList.unshift({ id: -1, CustomerFriendlyName: "All Customers" });
      let returnList = customerList.filter((customerSearch) => {
        return customerSearch.CustomerFriendlyName.toLowerCase().includes(this.selected_customer_name.toLowerCase());
      });
      return returnList;
    },
  },
  watch: {
    dateRange: function () {
      document.cookie = `dateRange=${JSON.stringify(this.dateRange)};`;
    },
  },
  async mounted() {},
};
</script>

<style>
.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #47d047 !important;
}

.daterangepicker td.in-range {
  background-color: #47d0613d;
}

.date-selection-header {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

@media screen and (min-width: 769px) {
  .level {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>

<style scoped>
.top-bar {
  max-height: 200px;
}
.booking-chart {
  min-height: 300px;
}
.big-chart {
  min-height: 450px;
}
.horizontal-seperator {
  height: 2px;
  background-color: #d3d3d352;
  margin: 30px 20px;
  border-radius: 10px;
}
.vertical-seperator {
  width: 2px;
  background-color: #d3d3d352;
  margin: 20px 30px;
  border-radius: 10px;
}
.table-height {
  max-height: 500px;
  position: relative;
  height: 500px;
}

.level {
  gap: 20px;
}
</style>
